import FullLogo from 'assets/images/full-logo-blockchain-lightblue.svg'
import Column from 'components/Column'
import Link from 'components/Link'
import Row from 'components/Row'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { color, zIndex } from 'utils'
import { getMobileOS } from 'utils/mobile'

import AmigoEasterEgg from './AmigoEasterEgg'
import MobileBanners from './MobileBanners'
import NavigationMenu from './NavigationMenu'

const TopHeader = styled(Column)<{ height: string }>`
  position: fixed;
  top: 0;
  left: 0;
  height: ${(p) => p.height};
  width: 100%;
  color: ${color('white')};
  background: ${color('dark900')};
  z-index: ${zIndex(2)};
  justify-content: flex-start;
`

const InnerHeader = styled(Row)`
  padding: 0 1rem;
  gap: 4rem;
  height: 100%;
`

const Spacer = styled.div<{ height: string }>`
  width: 100%;
  height: ${(p) => p.height};
`

const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
`

const Disclaimer = styled.div`
  text-align: center;
  color: ${color('ukFinPromText')};
  background: ${color('ukFinPromBannerBackground')};
  padding: 0.5rem 1rem;

  > a {
    text-decoration: underline;
    font-weight: 700;
  }
`

const ExchangeNotice = styled.div`
  text-align: center;
  color: ${color('white')};
  background: ${color('blue600')};
  padding: 0.5rem 1rem;
  border-top: 1px solid ${color('grey200')};

  > a {
    text-decoration: underline;
    font-weight: 700;
    color: ${color('white')};
  }
`

const Header = ({ showDisclaimer }) => {
  const mobileOs = getMobileOS()
  const [showMobileBanners, setShowMobileBanners] = React.useState(true)
  const [disclaimerSize, setDisclaimerSize] = useState(0)
  const [exchangeNoticeSize, setExchangeNoticeSize] = useState(0)
  const navbarSize = showMobileBanners && mobileOs ? 135 : 56
  const headerSize = `${navbarSize + (showDisclaimer ? disclaimerSize : 0) + exchangeNoticeSize}px`

  useEffect(() => {
    const updateBannerSizes = () => {
      const disclaimerElement = document.getElementById('disclaimer')
      const exchangeNoticeElement = document.getElementById('exchange-notice')

      if (disclaimerElement) {
        setDisclaimerSize(disclaimerElement.clientHeight)
      }
      
      if (exchangeNoticeElement) {
        setExchangeNoticeSize(exchangeNoticeElement.clientHeight)
      }
    }

    // Add delay to ensure elements are rendered
    const timeoutId = setTimeout(updateBannerSizes, 100)
    window.addEventListener('resize', updateBannerSizes)

    return () => {
      clearTimeout(timeoutId)
      window.removeEventListener('resize', updateBannerSizes)
    }
  }, [showDisclaimer])

  const navigate = useNavigate()

  return (
    <>
      {/* Header is fixed, so adding this empty spacer so you can't scroll
      beyond the header size */}
      <Spacer height={headerSize} />
      <TopHeader height={headerSize}>
        <AmigoEasterEgg />
        {showMobileBanners && <MobileBanners onClose={() => setShowMobileBanners(false)} />}
        <InnerHeader>
          <LogoLink onClick={() => navigate('/trade')}>
            <img src={FullLogo} />
          </LogoLink>
          <NavigationMenu />
        </InnerHeader>
        {showDisclaimer && (
          <Disclaimer id='disclaimer'>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            Don't invest unless you're prepared to lose all the money you invest. This is a
            high-risk investment and you should not expect to be protected if something goes wrong.{' '}
            <Link
              href='https://support.blockchain.com/hc/en-us/articles/10618857176604-UK-FCA-Regulations'
              target='_blank'
              color='ukFinPromText'
              inline
            >
              Take 2 mins to learn more
            </Link>.           
          </Disclaimer>
        )}
        <ExchangeNotice id='exchange-notice'>
          <b>Exchange is now integrated into our upgraded brokerage trading platform, featuring advanced trading tools like limit orders for a seamless experience.</b>
          <br />
          By integrating the Exchange into a unified Wallet experience, you'll enjoy a cohesive all-in-one trading hub without having to switch between apps. Your funds remain secure throughout the process, and you can still access balances or withdraw assets to external wallets or bank accounts as needed.
          <br />
          <br />
          To continue trading, please login to the <Link
            href='https://login.blockchain.com/auth/login?product=wallet'
            target='_blank'
            color='ukFinPromText'
            inline
          >
            Blockchain.com Wallet app
          </Link> and migrate your funds there.
        </ExchangeNotice>
      </TopHeader>
    </>
  )
}

export default Header
